import moment from "moment";

/**
 * Utility functions for call reports.
 */
export const callReportsUtils = {
  /**
   * Sanitizes the date range by ensuring the 'fromDate' is not after 'toDate' and
   * the difference between 'fromDate' and 'toDate' is no greater than six months.
   * If 'fromDate' is after 'toDate', it resets both dates to default values.
   * If 'fromDate' is more than six months before 'toDate', it sets 'fromDate' to six months before 'toDate'.
   *
   * @param {Date} fromDate - The start date of the range.
   * @param {Date} toDate - The end date of the range.
   * @returns {{ sanitizedFromDate: Date, sanitizedToDate: moment.Moment, message? : string}} - The sanitized date range and a message if the range was sanitized.
   */
  sanitizeDateRange: (fromDate, toDate) => {
    const minFromDate = moment(toDate).subtract(6, "months");

    if (moment(fromDate).isAfter(toDate)) {
      return {
        sanitizedFromDate: moment().subtract("3", "month"),
        sanitizedToDate: moment(),
        message: "The start date cannot be after the end date.",
      };
    }

    if (moment(toDate).isBefore(fromDate)) {
      return {
        sanitizedFromDate: moment().subtract("3", "month"),
        sanitizedToDate: moment(),
        message: "The end date cannot be before the start date.",
      };
    }

    if (moment(fromDate).isBefore(minFromDate)) {
      return {
        sanitizedFromDate: minFromDate,
        sanitizedToDate: toDate,
        message: "Can't search for more than 6 months back.",
      };
    }

    return {
      sanitizedFromDate: fromDate,
      sanitizedToDate: toDate,
    };
  },
};
